import { getEvents, editEvent, createEvent, getEventsByCompanyId, getEventById, getEventDetailsData } from '../api';
import { sortArrayByFieldAsc } from '../helpers/general';
import { dispatchErrorAction } from './index';
import * as actionTypes from './actionTypes';
import { formatEventScheduleData } from '../helpers/fromServer';

export function getEventSchedule (id) {
  return dispatch => getEventDetailsData(id)
    .then(({ data }) => {
      const eventData = formatEventScheduleData(data);
      dispatch({ type: actionTypes.GET_EVENT_SCHEDULE_SUCCESS, payload: eventData });
      return eventData;
    })
    .catch(error => { dispatchErrorAction(error, dispatch); });
}

export function getEventsAction (companyId, time_zone_id, jobStartDate) {
  return dispatch => getEvents(companyId, time_zone_id, jobStartDate)
    .then(data => {
      const sortedEventsList = sortArrayByFieldAsc(data.data, 'name');
      dispatch({ type: actionTypes.GET_EVENTS_SUCCESS, payload: sortedEventsList });
    })
    .catch(error => dispatchErrorAction(error, dispatch));
}

export function editEventAction (id, eventData) {
  return dispatch => editEvent(id, eventData)
    .then(data => {
      dispatch({ type: actionTypes.EDIT_EVENT_SUCCESS, payload: data.data });
    })
    .catch(error => dispatchErrorAction(error, dispatch));
}

export function createEventAction (eventData) {
  return dispatch => createEvent(eventData)
    .then(({ data }) => {
      dispatch({ type: actionTypes.CREATE_EVENT_SUCCESS, payload: data });
      return data;
    })
    .catch(error => dispatchErrorAction(error, dispatch));
}

/**
 * @param {string} input
 * */
export function getCompanyEvents (input) {
  return dispatch => getEventsByCompanyId(input)
    .then(({ data }) => dispatch({ type: actionTypes.GET_COMPANY_EVENTS_SUCCESS, data }))
    .catch(error => dispatchErrorAction(error, dispatch));
}

/**
 * @param {number} id
 * */
export function getEventDetails (id) {
  return dispatch => getEventById(id)
    .then(({ data }) => dispatch({ type: actionTypes.GET_EVENT_DETAILS_SUCCESS, data }))
    .catch(error => dispatchErrorAction(error, dispatch));
}



// WEBPACK FOOTER //
// ./src/actions/events.js